import ParamsService from 'services/params.service';

const config = {
    baseURL: `https://forms.hubspot.com`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
};

const endpoints = api => ({
    form: ({ portal, form, params }) =>
        api.post(`/uploads/form/v2/${portal}/${form}`, ParamsService.stringify(params), config),
});

export default endpoints;
